import type { ConceptDef } from '../types';

const find = (id: string, name: string, scene: string, parts: string[]): ConceptDef => ({
  kind: 'findPart',
  id,
  label: name,
  category: 'Receptive',
  description: `Hear “touch the …” and touch that part of the ${scene === 'plane' ? 'aeroplane' : scene}.`,
  config: { scene, parts, promptMode: 'AUDIO', errorless: 'off' },
});

export const findHouse = find('find-house', 'Touch: Parts of a House', 'house', ['roof', 'chimney', 'door', 'window', 'path', 'fence']);
export const findFace = find('find-face', 'Touch: Parts of the Face', 'face', ['eyes', 'nose', 'mouth', 'ears', 'hair', 'cheeks', 'chin', 'eyebrows']);
export const findBody = find('find-body', 'Touch: Body Parts', 'body', ['head', 'shoulder', 'arm', 'elbow', 'hand', 'tummy', 'knee', 'foot']);
export const findCar = find('find-car', 'Touch: Parts of a Car', 'car', ['wheels', 'door', 'headlight', 'bonnet', 'boot', 'plate', 'bumper']);
export const findPlane = find('find-plane', 'Touch: Parts of an Aeroplane', 'plane', ['wing', 'tail', 'cockpit', 'engine', 'wheels', 'windows']);
export const findDog = find('find-dog', 'Touch: Parts of a Dog', 'dog', ['ear', 'tail', 'paws', 'nose', 'eye', 'collar']);

const place = (id: string, name: string, mover: string, parts: string[], description: string): ConceptDef => ({
  kind: 'placeIt',
  id,
  label: name,
  category: 'Receptive',
  description,
  config: { scene: 'room', parts, mover, promptMode: 'AUDIO', errorless: 'off' },
});

export const placeInOnUnder = place('place-in-on-under', 'Prepositions: In, On, Under', 'cat', ['on-table', 'under-table', 'in-box', 'on-bed'], 'Put the cat in, on or under things in the room.');
export const placeNextBehind = place('place-next-behind', 'Prepositions: Next To, Behind', 'ball', ['next-table', 'next-box', 'behind-box', 'under-bed'], 'Put the ball next to, behind or under things.');
export const placeAll = place('place-all', 'Prepositions: All Places', 'teddy', ['on-table', 'under-table', 'next-table', 'in-box', 'behind-box', 'next-box', 'on-bed', 'under-bed'], 'Put the teddy in every kind of place.');
